import { allPartOfTheDay, type PartOfTheDay } from '$/_const/PartOfTheDay.ts';
import type { DayRow, MissingRow } from '$/dto/ItineraryData.dto.ts';
import orderActivitiesByPartOfDay from '$/utils/orderActivitiesByPartOfDay.ts';

export type TimelineEntry = { kind: 'row'; row: DayRow } | { kind: 'missing'; missing: MissingRow };

const partIndex = (part: PartOfTheDay): number => {
  const index = allPartOfTheDay.indexOf(part);

  return index === -1 ? allPartOfTheDay.length : index;
};

const mergeMissingRows = (activities: DayRow[], missingRows: MissingRow[] | undefined): TimelineEntry[] => {
  const timeline = orderActivitiesByPartOfDay(activities).map((row): TimelineEntry => ({ kind: 'row', row }));
  const missing = [...(missingRows ?? [])].sort(
    (first, second) => partIndex(first.part_of_the_day) - partIndex(second.part_of_the_day)
  );

  for (const slot of missing) {
    const position = timeline.findIndex(
      (entry) => entry.kind === 'row' && partIndex(entry.row.part_of_the_day) > partIndex(slot.part_of_the_day)
    );

    timeline.splice(position === -1 ? timeline.length : position, 0, { kind: 'missing', missing: slot });
  }

  return timeline;
};

export default mergeMissingRows;
